import { ConciergeProductKnowledgeParser } from "@redotech/redo-model/concierge-settings/product-knowledge";
import * as z from "zod/v4";

export const getProductSettings = {
  name: "getProductSettings" as const,
  input: z.object({ identifier: z.string() }),
  output: z.object({
    productName: z.string(),
    hidden: z.boolean(),
    knowledge: ConciergeProductKnowledgeParser.optional(),
  }),
};
